

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"6","height":"10","viewBox":"0 0 6 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M3.98378 5.00211L0.163077 1.26098C0.0578737 1.15821 -4.76837e-07 1.02081 -4.76837e-07 0.874309C-4.76837e-07 0.727724 0.0578737 0.590406 0.163077 0.48748L0.497868 0.159837C0.602905 0.056748 0.743315 0 0.892941 0C1.04257 0 1.18281 0.056748 1.28793 0.159837L5.83709 4.61398C5.94262 4.71724 6.00041 4.8552 6 5.00187C6.00041 5.14919 5.9427 5.28699 5.83709 5.39033L1.29217 9.84016C1.18705 9.94325 1.0468 10 0.897093 10C0.747467 10 0.607224 9.94325 0.50202 9.84016L0.167312 9.51252C-0.0504847 9.29927 -0.0504847 8.95211 0.167312 8.73894L3.98378 5.00211Z","fill":"#342245"}, []), "\n"]);
};

        